import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: startDate => ({
        date: Math.floor(startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'iaasGlobalInformation',
        endpoint:           endpoints.iaas.globalInformation,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => ({
            results: !response.results ? {} : {vcenter: response.results.vcenter.map(item => ({
                vcenterName:  item.vcenter_name,
                vmOn:         item.total_vm_on,
                vmOff:        item.total_vm_off,
                totalCpu:     item.total_cpu,
                cpuOn:        item.total_cpu_on,
                cpuOff:       item.total_cpu_off,
                totalRam:     item.total_ram,
                ramOn:        item.total_ram_on,
                ramOff:       item.total_ram_off,
                totalStorage: item.total_storage_mb / (1024 * 1000),
                storageOn:    item.total_storage_on_mb / (1024 * 1000),
                storageOff:   item.total_storage_off_mb / (1024 * 1000)
            })),
            vcloud: response.results.vcloud.map(item => ({
                vdcClient:    item.vdc_name,
                vmOn:         item.total_vm_on,
                vmOff:        item.total_vm_off,
                totalCpu:     item.total_cpu,
                cpuOn:        item.total_cpu_on,
                cpuOff:       item.total_cpu_off,
                totalRam:     item.total_ram,
                ramOn:        item.total_ram_on,
                ramOff:       item.total_ram_off,
                totalStorage: item.total_storage_mb / (1024 * 1000),
                storageOn:    item.total_storage_on_mb / (1024 * 1000),
                storageOff:   item.total_storage_off_mb / (1024 * 1000)
            }))
            }})
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/iaasGlobalInformation.js